import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/service/home.service';
import { catchError, EMPTY } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { HeaderComponent } from 'src/app/core/header/header.component';
import { ResolveStart, Router } from '@angular/router'
import { MsalService } from 'src/app/msal';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [HeaderComponent]
})
export class HomeComponent implements OnInit {
  userDetails: any = {};
  siteList: any = [];
  primarySite: any;
  primarySiteName: any;
  subscribeFlag = false;
  constructor(private router: Router, private homeService: HomeService, private ngxUiLoaderService: NgxUiLoaderService, private constants: Constants, private headerComponent: HeaderComponent, public authService: MsalService) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.homeService.userDetails.subscribe((data: any) => {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent);
      if (this.subscribeFlag == false) {
        this.getSiteList();
      }
      this.subscribeFlag = true;
    })
  }

  changeSite() {
    let reqObj = {
      primarysiteid: this.primarySite
      , authcode: this.userDetails.authcode
      , emailid: this.userDetails.emailId
      , firstname: this.userDetails.firstName
      , guid: this.userDetails.guid
      , lastname: this.userDetails.lastName
      , password: this.userDetails.password
      , status: this.userDetails.status
      , upn: this.userDetails.upn
      , id: this.userDetails.id
    };
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.homeService.changePrimarySite(reqObj).subscribe({
      next: (response: any) => {
        if (response.status) {         
          let userId = localStorage.getItem("toyotaGUID");
          this.ngxUiLoaderService.start(this.constants.LoaderComponent);
          if(userId != null) {
            this.homeService.getUserDetails(userId).pipe(
              catchError((error: any) => {
                // this.router.navigate(['./unauthorized']);
                this.router.navigate(['/'])
                localStorage.clear();
                sessionStorage.clear();
                setTimeout(() => {
                  this.authService.logout();
                }, 1000);
                return EMPTY;
              })).subscribe((response: any) => {
                if (response?.status == true) {
                  this.headerComponent.site = this.siteList.filter((x: any) => x.id == this.primarySite)[0].name;
                  this.primarySiteName = this.siteList.filter((x: any) => x.id == this.primarySite)[0].name;
                  this.homeService.primarySite.emit(this.primarySiteName);
                  this.userDetails.primarySiteName = this.primarySiteName;
                  this.userDetails.primarySiteId = this.primarySite;     
                  this.userDetails.role = this.roleUniqueArr;
                  localStorage.removeItem("userDetails");                  
                  sessionStorage.removeItem("userDetails");
                  sessionStorage.removeItem("siteConfigRules");            
                  localStorage.setItem("userDetails", JSON.stringify(response.user));
                  sessionStorage.setItem("userDetails", JSON.stringify(response.user));
                  sessionStorage.setItem("siteConfigRules", JSON.stringify(response.siteConfigRules));
                  this.roleUniqueArr = this.formatRolesString(this.userDetails.role1, this.primarySiteName);                  
                  this.homeService.updateSiteValue.emit();             
                  this.homeService.updateUserRole.emit();
                  sessionStorage.setItem("ChangedRole", 'true'); 
                  setTimeout(() => {
                    this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
                  }, 5000);
                }
              });
          }
        }
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      },
      complete: () => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      }
    }
    );
  }

  getSiteList() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    const siteListStr = sessionStorage.getItem("siteList");
    if (siteListStr !== null) {
      this.siteList = JSON.parse(siteListStr);
      this.siteList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      console.log(this.siteList)
    }
    this.getUserDetails();
  }

  getUserDetails() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    const userDetailsStr = sessionStorage.getItem("userDetails");
    if (userDetailsStr !== null) {
      this.userDetails = JSON.parse(userDetailsStr);
      this.primarySite = this.userDetails.primarySiteId;
      this.primarySiteName = this.userDetails.primarySiteName;
      this.validatedRole = this.verifyByRole('Multiple Site');
      console.log(this.validatedRole)
      this.homeService.primarySite.emit(this.primarySiteName);
      setTimeout(() => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      }, 200);
    } else {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      // this.Router.navigate(['/unauthorized'])
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/unauthorized', 'fvm','true']);
      this.authService.logout();
    }
  }

  validatedRole: boolean = false;
  roleUniqueArr: any = [];
  siteListToDisplay: any = [];

  verifyByRole(module: any): boolean {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    let moduleArr = module.split(',');
    let returnValue = true;
    this.roleUniqueArr = this.userDetails?.role;
    this.siteListToDisplay = this.userDetails?.role1;
    if (this.siteListToDisplay && Object.keys(this.siteListToDisplay).length > 0) {
      moduleArr.forEach((element: any) => {
        if (returnValue) {
          returnValue = this.hasRole(this.siteListToDisplay, 'ALL', element)
        }
      });
    };
    return returnValue;
  }

  hasRole(role1: any, role: any, element: any) {
    if (role1) {
      if (role1[`${role}`]) {
        return role1[`${role}`].some((x: any) => {
          return x.name == element.trim()
        })
      }
    }
  }

  formatRolesString(role1: any, primarySiteName: string): any {
    let roleUniqueArr: any = [];
    if (role1) {
      let roleArr: any = [];

      if (role1['ALL']) {
        role1['ALL'].map((x: any) => {
          roleArr.push(x.name)
        })
      }
      if (role1[primarySiteName]) {
        role1[primarySiteName].map((x: any) => {
          roleArr.push(x.name)
        })
      }
      roleUniqueArr = Array.from(new Set(roleArr))
      roleUniqueArr.sort();
    }
    return roleUniqueArr;
  }

}
